<template>    
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Firma Cliente        
        </v-card-title>
        
        <v-layout wrap align-center>                            
            <v-flex xs10 offset-xs1 mb-3>
              <SignaturePad/>
            </v-flex>
            <br>          
            <v-flex xs8 offset-xs2 mb-5>
              <v-btn block color="success" dark @click="closeOK">Finalizar</v-btn>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
</template>
<script>
import SignaturePad from '@/components/SignaturePad.vue'
export default {
    name: 'dialogSignatureCustomer',
    components:{      
      SignaturePad
    },
    data () {
      return {                
      }
    },
    methods:{
        close(){
            this.dialog = false;                        
        },
        closeOK(){            
            this.dialog = false;                        
        }
    },
    mounted(){
      
    },
    watch:{      
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogSignatureCustomer;
            },
            set(value){
                this.$store.state.dialogSignatureCustomer = value;
            }
        },        
    }
}
</script>

